import React, { type ReactNode, type RefCallback } from 'react';

import { cssMap } from '@atlaskit/css';
import { Box } from '@atlaskit/primitives/compiled/box';
import VisuallyHidden from '@atlaskit/visually-hidden/visually-hidden';

const styles = cssMap({
	// Contain the live region without adding layout space or document overflow.
	container: {
		position: 'fixed',
		insetBlockStart: 0,
		insetInlineStart: 0,
		width: 0,
		height: 0,
		pointerEvents: 'none',
	},
});

export function StatusAnnouncement({
	children,
	contentRef,
}: {
	children?: ReactNode;
	contentRef?: RefCallback<HTMLSpanElement>;
}): React.JSX.Element {
	return (
		<Box xcss={styles.container}>
			<VisuallyHidden>
				<span ref={contentRef} role="status">
					{children}
				</span>
			</VisuallyHidden>
		</Box>
	);
}
